import React, { lazy,useEffect, useState } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import * as EnvConstants from "../src/Constants/EnvConstants";
import { QueryStringProvider } from "./Contexts/QueryString";
import { VisitorParamsProvider } from "./Contexts/VisitorParams";
import { queryString } from "./Utility/QueryString";
import "./App.scss";
import { RedirectProvider } from "./Contexts/RedirectContext";
import { ReferenceProvider } from "./Contexts/ReferenceContext";

const AllRoutes = process.env.REACT_APP_ENV !== "local"
  ? lazy(() => import("./Routes/AllRoutes"))
  : () => null;
const Unqualified = lazy(() => import('./Components/Pages/Unqualified'));
const FbPixel = lazy(() => import('./Components/Pages/FbPixel'));

const UFC_DC_V4_Routes = lazy(() => import("./Routes/UFC_DC_V4_Routes"));



const App = () => {
  const [visitorParameters] = useState({ visitor_parameters: [], data: [] });
  const [redirectUrl] = useState({ redirectUrl: '' });
  useEffect(() => {
    document.title = EnvConstants.AppTitle;
  }, []);
  const [referenceID,setReferenceID] = useState("");
  return (
    <>
      <VisitorParamsProvider value={{ visitorParameters }}>
        <QueryStringProvider value={{ queryString }}>
          <RedirectProvider value={{ redirectUrl }}>
          <ReferenceProvider value={{ referenceID,setReferenceID }}>
            <BrowserRouter>
              <React.Suspense fallback={<div style={{ color: '#FFFFFF' }}>Loading...</div>}>
              {process.env.REACT_APP_ENV !== "local" && <AllRoutes />}

              <Route exact path="/unqualified" component={Unqualified} />
              <Route exact path="/fbpixel" component={FbPixel} />
             
              <UFC_DC_V4_Routes />
    
              </React.Suspense>
             </BrowserRouter>
             </ReferenceProvider>
          </RedirectProvider>
        </QueryStringProvider>
      </VisitorParamsProvider>
    </>
  );
};

export default App;
